import { deviceType } from "../enums";
import { ICustomer } from "../interfaces-and-types";

export const customersDataHelper: ICustomer[] = [
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    fullName: "",
    email: "customer1@gmail.com",
    ipAddress: "192.168.34.12",
    deviceType: deviceType.pc,
  },
  {
    id: "a231-5648cc43-56123c43-237d0098-1ac3",
    fullName: "test customer name",
    email: "customer2@gmail.com",
    ipAddress: "192.163.34.87",
    deviceType: deviceType.pc,
  },
  {
    id: "18dd-11111d43-56123c43-237d0098-1ac3",
    fullName: "tester customer",
    email: "customer3@gmail.com",
    ipAddress: "124.263.26.122",
    deviceType: deviceType.mobile,
  },
  {
    id: "c423-11111d43-56123c43-00001234-1ac3",
    fullName: "tester customer",
    email: "customer3@gmail.com",
    ipAddress: "124.263.26.122",
    deviceType: deviceType.mobile,
  },
  {
    id: "a32a-c3c4c5c6-56123c43-237d0098-1ac3",
    fullName: "tester customer",
    email: "customer3@gmail.com",
    ipAddress: "124.263.26.122",
    deviceType: deviceType.mobile,
  },
];
